var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { RequerimentoCustomRadioGroup } from '../../../../components/RequerimentoCustomRadioGroup';
import { useRequerimentoContext } from '../context/RequerimentoContext';
import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { ShowContent } from '../../../../components/ShowContent';
import { TipoDocumentoEnum } from '../../../../model/enums/TipoDocumentoEnum';
export var TipoRequerente = function (_a) {
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange;
    var _b = useRequerimentoContext(), tipoRequerente = _b.tipoRequerente, setTipoRequerente = _b.setTipoRequerente, _requerimento = _b._requerimento, verifyTipDoc = _b.verifyTipDoc;
    var requerimento = _requerimento[0], setRequerimento = _requerimento[1];
    useEffect(function () {
    }, [requerimento]);
    useEffect(function () {
        setTipoRequerente(requerimento.tipoRequerente);
    }, [requerimento.tipoRequerente]);
    var handleChange = function (event) {
        var value = event.target.value;
        setRequerimento(function (prevState) { return (__assign(__assign({}, prevState), { tipoRequerente: value, requerentePf: undefined, requerentePj: undefined, requerimentoInventariante: undefined, procurador: undefined })); });
        setTipoRequerente(value);
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange({});
    };
    return (_jsxs(Box, __assign({ sx: { p: 0, background: 'transparent' } }, { children: [_jsx(ShowContent, __assign({ show: verifyTipDoc(TipoDocumentoEnum.PF) }, { children: _jsx(RequerimentoCustomRadioGroup, { value: tipoRequerente, onChange: handleChange, sx: { flexDirection: 'column' }, options: [
                        { value: 'REQUERENTE', label: 'Sou o Requerente' },
                        { value: 'PROCURADOR', label: 'Sou o Procurador' },
                        { value: 'INVENTARIANTE', label: 'Sou o Inventariante' },
                    ] }) })), _jsx(ShowContent, __assign({ show: verifyTipDoc(TipoDocumentoEnum.PJ) }, { children: _jsx(RequerimentoCustomRadioGroup, { value: tipoRequerente, onChange: handleChange, sx: { flexDirection: 'column' }, options: [
                        { value: 'REQUERENTE', label: 'Sou o Representante Legal' },
                        { value: 'PROCURADOR', label: 'Sou o Procurador' },
                    ] }) }))] })));
};
